export const addSearchParams = (url: string, params: Record<string, string | string[]> = {}) => {
  const isAbsoluteUrl = url.startsWith('http')
  const baseAbsoluteUrl = isAbsoluteUrl ? url : `http://www.example.com${url}`
  const { origin, pathname, searchParams } = new URL(baseAbsoluteUrl)

  const newSearchParams = new URLSearchParams([
    ...Array.from(searchParams.entries()),
    ...Object.entries(params).flatMap(([key, value]) =>
      Array.isArray(value) ? value.map(v => [key, v]) : [[key, value]]
    ),
  ])

  const baseUrl = isAbsoluteUrl ? `${origin}${pathname}` : pathname
  return `${baseUrl}?${newSearchParams}`
}